export enum TimeType {
  DEPARTURE = 'DEPARTURE',
  ARRIVAL = 'ARRIVAL',
}
